/**
 * Created by eliasmj on 31/10/2014.
 */
angular.module('qkr').controller('OutletsController',
    function($scope, merchantService, outletService, messageService, $uibModal,
             $window, appConfig, appUrl, gettextCatalog, $location,
             contactDetailsData, paginationService, merchant, supportedCountries, integrationSettingsService) {

    $scope.isReportManager = appConfig.isReportManager;
    const LIVE = 'LIVE';
    const OFFLINE = 'OFFLINE';
    const TRIAL = 'TRIAL';

    const vm = this;
    const max = 10;
    vm.isProd = appConfig.env === 'production';
    vm.merchant = merchant;
    vm.outletsMapIsVisible = true;
    vm.outlets = [];

    vm.showInput = false;

    // Filter search var to the directive
    vm.selectedStateFilter = '';
    vm.states = contactDetailsData.map(obj => {
        return obj.state;
    });
    vm.searchText = null;

    /* ----------------------------------------------------------------------------------------------*/
    //  Pagination functions

    vm.pageChanged = function(selectedPage, disabled) {
        if (!disabled) {
            vm.loadOutlets(selectedPage, (selectedPage - 1) * max);
        }
    };

    vm.buildPage = function(itemAmount, currentPage, pageSize) {
        vm.pageService = paginationService.getPages(itemAmount, currentPage, pageSize);

        // Set visibility
        vm.isToShowFilterPagination = vm.pageService && vm.pageService.totalItems > 10 && !vm.outlets.noResult;
    };
    /* ----------------------------------------------------------------------------------------------*/

    vm.getStatusColor = function(status) {
        const outletStatus = vm.statusOptions.find(st => st.value === status);
        return outletStatus.color;
    };

    vm.getStateDisplayName = function() {
        let supportedCountry;
        // Conditional check as some merchants that were created years ago don't have certain attributes. Such as,
        // contactDetails.
        if (merchant.contactDetails) {
            supportedCountry = supportedCountries
                .find(countries => countries.name === merchant.contactDetails.country.name).stateDisplayName;
        }
        return supportedCountry ? supportedCountry : gettextCatalog.getString('State / County');
    };

    vm.getOutletCity = function(outlet) {
        return outlet.contactDetails.city ? outlet.contactDetails.city : '-';
    };

    vm.statusOptions = [
        {name: (gettextCatalog.getString('Offline')), value: OFFLINE, color: '#FF0000'},
        {name: (gettextCatalog.getString('Trial')), value: TRIAL, color: '#FFA500'},
        {name: (gettextCatalog.getString('Live')), value: LIVE, color: '#008000'}
    ];

    // The user selects a category
    vm.selectStateFilter = function(selectedFilter) {
        if (vm.selectedStateFilter === selectedFilter)
            vm.selectedStateFilter = ''; // Deselect
        else
            vm.selectedStateFilter = selectedFilter;

        vm.updateOutlets();
    };

    vm.containRole = function(role) {
        return appConfig.userRoles.indexOf(role) !== -1;
    };

    vm.goToStoreFront = function(outlet) {
        outletService.loadOutlet(outlet.id).then((promise) => {
            $window.location.href = appConfig.contextPath + appUrl.storeFront;
        });
    };

    vm.showOutletAppearanceSettings =function(outlet) {
        outletService.loadOutlet(outlet.id).then((promise) => {
            $window.location.href = appConfig.contextPath + appUrl.storeFront + "#/storefront_appearance";
        });
    };

    $scope.isMaxOutletReached = function() {
        return merchant &&
            merchant.businessCategory &&
            merchant.businessCategory.name === 'Charity' && vm.outlets.length > 0;
    };

    vm.showCreateOutletButton = function() {
        if ($scope.isReportManager) {
            return false;
        } else {
            return merchantService.behaviour(merchantService.merchantInfo, 'outletsPage.showCreateOutletButton') &&
                !$scope.isMaxOutletReached();
        }
    };

    vm.setName = function(outlet) {
        if (!vm.clickid) {
            vm.clickid = outlet.id;
        }

        let isSave = false;

        if (vm.clickid && outlet.id === vm.clickid) {
            // If is true because is to check btn
            if (vm.showInput) {
                vm.clickid = null;
                isSave = true;
            }

            vm.showInput = !vm.showInput;
        }

        const commandOutlet = {};
        commandOutlet.id = {};
        commandOutlet.id.id = outlet.id;
        commandOutlet.name = outlet.name;

        if (isSave) {
            outletService.setName(commandOutlet).then(
                (response) => {
                    console.log('setName response', response);
                },
                (reason) => {
                    console.error(reason);
                }
            );
        }
    };

    vm.setStatus = function(outlet) {
        const newStatus = outlet.displayStatus;
        const modalInstance = $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return gettextCatalog.getString('Update Outlet Status');
                },
                confirmButtonName() {
                    return gettextCatalog.getString('OK');
                },
                confirmMsg() {
                    if (!merchant.paymentConfig && merchantService.behaviour(merchantService.merchantInfo, 'schoolLike') && newStatus === 'LIVE') {
                        return ettextCatalog.getString("You haven't set a payment configuration for this outlet, are you sure you would like to change the status of this outlet to")
                            + " " + gettextCatalog.getString(newStatus) + '?';
                    } else {
                        return gettextCatalog.getString('Are you sure you want to set the status of this outlet to')
                            + ' ' + gettextCatalog.getString(newStatus) + '?';
                    }
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result === 'ok') {
                const commandOutlet = {};
                commandOutlet.id = {};
                commandOutlet.id.id = outlet.id;
                commandOutlet.status = newStatus;

                outletService.setStatus(commandOutlet).then((response) => {
                }, (reason) => { // error condition
                    messageService.error('Error to setStatus', reason);
                    outlet.displayStatus = outlet.status;
                    const modalInstance2 = $uibModal.open({
                        template: require('../../templates/common/modalPopup.html'),
                        controller: 'CommonModalPopupController',
                        windowClass: 'fade',
                        backdrop: 'static',
                        resolve: {
                            title() {
                                return 'Set Status Error';
                            },
                            message() {
                                return reason.data.exception;
                            }
                        }
                    });
                });
            } else { // cancel
                outlet.displayStatus = outlet.status;
            }
        }, () => {});
    };

    vm.bulkUpload = function() {
        const modalInstance = $uibModal.open({
            template: require('../../controllers/merchant/outlet/outlet-bulk-upload.html'),
            controller: 'outletBulkUploadController',
            controllerAs: '$ctrl',
            windowClass: 'fade outlet-upload-modal',
            backdrop: 'static',
            resolve: {
                posType() {
                     return merchant.merchantPosProperties.posType;
                }
            }

        });
        modalInstance.result.then((result) => {
            $window.location.reload();
        }, () => {});
    };

    vm.updateOutlets = function() {
        vm.outlets = [];
        vm.loadOutlets(null, null);
    };

    vm.loadOutlets = function(currentPage, offset) {
        vm.outlets.noResult = null;

        const form = {
            searchText: vm.searchText === null ? null : vm.searchText.toLowerCase(),
            selectedState: vm.selectedStateFilter ? vm.selectedStateFilter : null,
            selectedCity: null,
            offset: offset || 0,
            max                     // Fixes 'property shorthand' eslint warning, no need to sign value to itself.
        };
        outletService.listPaginatedOutlets(form).then((paginatedOutlets) => {
            vm.buildPage(paginatedOutlets[1], currentPage, max);
            if (paginatedOutlets[0].length === 0) {
                vm.outlets.noResult = 'No results match your search! Please try another query.';
                vm.isToShowFilterPagination = false;
            } else {
                vm.outlets = paginatedOutlets[0];
            }
        }, (reason) => {
            messageService.error(reason);
        });
    };

    const init = function() {
        vm.loadOutlets();

        // new integration settings
        const integrationDetails = integrationSettingsService.integrationDetails(merchant);
        // replacing the old code
        vm.isMicros = integrationDetails.isMicros;
        vm.isComtrex = integrationDetails.isComtrex;
        vm.isOmnivore = integrationDetails.isOmnivore;
     };

    // Ng-init, simply call your init() Since your controller runs before
    init();
});



// WEBPACK FOOTER //
// ./src/controllers/merchant/outlets.controller.js